import strings from '@/language/Swedish';

type ColumnPriorityType = 'high' | 'normal' | 'low';

interface RegistryColumnType {
  name: string;
  label: string;
  priority: ColumnPriorityType;
}

interface RegistryFieldType {
  name: string;
  label: string;
  // Response field that must be accessible for this filter to be offered
  accessKey: string;
}

interface RegistryFieldGroupType {
  title: string;
  fields: RegistryFieldType[];
}

const registryColumns: RegistryColumnType[] = [
  { name: 'id', label: strings.registry.columns.id, priority: 'high' },
  { name: 'address', label: strings.registry.columns.address, priority: 'high' },
  { name: 'construction_year', label: strings.registry.columns.construction_year, priority: 'normal' },
  { name: 'home_type', label: strings.registry.columns.home_type, priority: 'normal' },
  { name: 'apartment_area', label: strings.registry.columns.apartment_area, priority: 'normal' },
  { name: 'apartment_category', label: strings.registry.columns.apartment_category, priority: 'low' },
  { name: 'apartment_nr', label: strings.registry.columns.apartment_nr, priority: 'high' },
  { name: 'area_name', label: strings.registry.columns.area_name, priority: 'low' },
  { name: 'building_purpose', label: strings.registry.columns.building_purpose, priority: 'low' },
  { name: 'building_type', label: strings.registry.columns.building_type, priority: 'low' },
  { name: 'county_code', label: strings.registry.columns.county_code, priority: 'low' },
  { name: 'municipality_code', label: strings.registry.columns.municipality_code, priority: 'low' },
  { name: 'floor', label: strings.registry.columns.floor, priority: 'low' },
  { name: 'floors', label: strings.registry.columns.floors, priority: 'low' },
  { name: 'kitchen_type', label: strings.registry.columns.kitchen_type, priority: 'low' },
  { name: 'ownership_type', label: strings.registry.columns.ownership_type, priority: 'low' },
  { name: 'postal_area', label: strings.registry.columns.postal_area, priority: 'high' },
  { name: 'property_key', label: strings.registry.columns.property_key, priority: 'low' },
  { name: 'rooms', label: strings.registry.columns.rooms, priority: 'low' },
  { name: 'type_code', label: strings.registry.columns.type_code, priority: 'low' },
];

const registryFieldGroups: RegistryFieldGroupType[] = [
  {
    title: strings.registry.groupAddress,
    fields: [
      { name: 'street', label: strings.registry.street, accessKey: 'address' },
      { name: 'number', label: strings.registry.number, accessKey: 'address' },
      {
        name: 'apartment_nr',
        label: strings.registry.apartmentNr,
        accessKey: 'apartment_nr',
      },
      { name: 'letter', label: strings.registry.letter, accessKey: 'address' },
      {
        name: 'postal_area',
        label: strings.registry.postalArea,
        accessKey: 'postal_area',
      },
      {
        name: 'postal_code',
        label: strings.registry.postalCode,
        accessKey: 'postal_area',
      },
    ],
  },
  {
    title: strings.registry.groupHouse,
    fields: [
      {
        name: 'property_key',
        label: strings.registry.propertyKey,
        accessKey: 'property_key',
      },
    ],
  },
  {
    title: strings.registry.groupLocation,
    fields: [
      {
        name: 'county_code',
        label: strings.registry.countyCode,
        accessKey: 'county_code',
      },
      {
        name: 'municipality_code',
        label: strings.registry.municipalityCode,
        accessKey: 'municipality_code',
      },
    ],
  },
  {
    title: strings.registry.groupAdvanced,
    fields: [
      {
        name: 'residential_ids',
        label: strings.registry.residentialIds,
        accessKey: 'id',
      },
    ],
  },
];

const defaultFilterValues: Record<string, string[]> = {
  street: [],
  number: [],
  apartment_nr: [],
  letter: [],
  postal_area: [],
  postal_code: [],
  property_key: [],
  county_code: [],
  municipality_code: [],
  residential_ids: [],
};

const DEFAULT_CENTER = { lat: 59.862215, lng: 17.64134 };
const DEFAULT_ZOOM = 13;
const RESULT_ZOOM = 14;

export {
  registryColumns,
  registryFieldGroups,
  defaultFilterValues,
  DEFAULT_CENTER,
  DEFAULT_ZOOM,
  RESULT_ZOOM,
};
export type { RegistryColumnType, RegistryFieldGroupType };
